export default __webpack_public_path__ + "static/media/cimb.1f714497.svg";